import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=dc60183a&"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc60183a')) {
      api.createRecord('dc60183a', component.options)
    } else {
      api.reload('dc60183a', component.options)
    }
    module.hot.accept("./Spinner.vue?vue&type=template&id=dc60183a&", function () {
      api.rerender('dc60183a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/Spinner.vue"
export default component.exports